import _objectWithoutProperties from "/home/bamboo/bamboo-agent-home/xml-data/build-dir/WEC-SIN33-JOB1/packages/web/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["title", "titleId"];
function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
import * as React from "react";
function Pin(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.size || 16,
    height: props.size || 16,
    viewBox: "0 0 24 24",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M11.977 1c4.95 0 8.978 4.026 8.978 8.977 0 5.601-7.727 12.666-8.978 12.666C10.726 22.643 3 15.578 3 9.977 3 5.026 7.028 1 11.977 1zm0 2A6.985 6.985 0 005 9.977c0 4.043 5.339 9.192 6.969 10.475 1.655-1.31 6.986-6.452 6.986-10.475C18.955 6.13 15.825 3 11.977 3zm0 3.013a4.091 4.091 0 014.087 4.087 4.09 4.09 0 01-4.087 4.086A4.09 4.09 0 017.89 10.1a4.09 4.09 0 014.086-4.087zm0 2A2.09 2.09 0 009.89 10.1c0 1.15.936 2.086 2.086 2.086a2.09 2.09 0 002.087-2.086 2.09 2.09 0 00-2.087-2.087z",
    fill: props.color || "#222",
    fillRule: "evenodd"
  }));
}
var MemoPin = React.memo(Pin);
export default MemoPin;